<template>
    <div class="bordas infos" v-if="validacao.dados.profissionalUltimaInternacao">
        <div class="alert alert-warning alert-infos" role="alert">
            <strong class="my-0 py-0">Última Admissão:</strong>
            <p class="my-0 py-0">{{validacao.dados.ultimaDataHoraInternacao}}</p>
            <p class="my-0 py-0">{{validacao.dados.profissionalUltimaInternacao}}</p>
        </div>

        <!-- <div class="alert alert-warning alert-infos mb-0" role="alert">
            <strong class="my-0 py-0">Última Alta:</strong>
            <p class="my-0 py-0" v-if="validacao">{{validacao.dados.ultimaDataHoraAlta}}</p>
            <p class="my-0 py-0" v-if="validacao">{{validacao.dados.profissionalUltimaAlta}}</p>
        </div> -->
    </div>
</template>

<script>
export default {
    computed: {
        validacao () {
            // Essa Action é disparada no Component BUSCA-UNIDADE
            return this.$store.getters['informacoes/getUltimasInternacoes']
        }
    }
}
</script>